import { useEffect } from 'react';
import { BRAND_DISPLAY_NAME, BRAND_OWNER } from '../data/brand.js';
import { OG_IMAGE_PATH, ROUTE_META, SITE_ORIGIN } from '../data/meta.js';
import { routeStructuredData } from '../data/structuredData.js';

export const upsertMeta = (selector, attr, value, content) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, value);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
};

export const upsertLink = (rel, href) => {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
};

// A JSON-LD block, keyed by id so a route swap replaces rather than stacks.
export const upsertJsonLd = (id, data) => {
    let el = document.head.querySelector(`script[data-ld="${id}"]`);
    if (!data) { if (el) el.remove(); return; }
    if (!el) {
        el = document.createElement('script');
        el.type = 'application/ld+json';
        el.setAttribute('data-ld', id);
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
};

export const useRouteMeta = (path, extra) => {
    useEffect(() => {
        const meta = ROUTE_META[path] || ROUTE_META['/'];
        // /case-study renders the same page as /how-floor-plans-work, so it
        // points its canonical there rather than competing with it.
        const canonical = SITE_ORIGIN + (meta.canonicalPath || path);
        const image = SITE_ORIGIN + OG_IMAGE_PATH;

        document.title = meta.title;
        upsertMeta('meta[name="author"]', 'name', 'author', BRAND_OWNER);
        upsertMeta('meta[name="description"]', 'name', 'description', meta.description);
        upsertMeta('meta[name="robots"]', 'name', 'robots', meta.noindex ? 'noindex,follow' : 'index,follow');
        upsertLink('canonical', canonical);

        upsertMeta('meta[property="og:url"]', 'property', 'og:url', canonical);
        upsertMeta('meta[property="og:title"]', 'property', 'og:title', meta.title);
        upsertMeta('meta[property="og:description"]', 'property', 'og:description', meta.description);
        upsertMeta('meta[property="og:image"]', 'property', 'og:image', image);
        upsertMeta('meta[property="og:site_name"]', 'property', 'og:site_name', BRAND_DISPLAY_NAME);
        upsertMeta('meta[name="twitter:title"]', 'name', 'twitter:title', meta.title);
        upsertMeta('meta[name="twitter:description"]', 'name', 'twitter:description', meta.description);
        upsertMeta('meta[name="twitter:image"]', 'name', 'twitter:image', image);

        for (const [id, data] of Object.entries(routeStructuredData(path, SITE_ORIGIN, extra))) {
            upsertJsonLd(id, data);
        }
    }, [path, extra]);
};
